(function() { module.exports = window["PropTypes"]; }());